import type { FulfillmentType } from '../types/@types/order';
import React from 'react';

export interface FulfillmentSelectorProps {
  value: FulfillmentType;
  disabled?: boolean;
  onChange: (next: FulfillmentType) => void;
  compact?: boolean;
}

export default function FulfillmentSelector({
  value,
  disabled,
  onChange,
  compact,
}: FulfillmentSelectorProps) {
  const base = compact ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';
  const option = (
    val: FulfillmentType,
    label: string,
  ) => (
    <label className={`cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
      <input
        type="radio"
        className="sr-only"
        value={val}
        checked={value === val}
        disabled={disabled}
        onChange={() => onChange(val)}
      />
      <span
        className={`${base} rounded border ${
          value === val
            ? 'bg-orange-500 border-orange-500 text-white'
            : 'bg-gray-100 border-gray-300 text-gray-800'
        }`}
      >
        {label}
      </span>
    </label>
  );
  return (
    <div className={`flex items-center ${compact ? 'gap-1' : 'gap-2'}`}>
      {option('DINE_IN', 'En mesa')}
      {option('TAKEOUT', 'Para llevar')}
    </div>
  );
}
